<template>
    <v-layout row wrap xs12 sm12 md12 lg12 ml-2 mr-2>

        <!--上一周 下一周 UI-->
        <v-flex   class=" xs12 sm12 md9 ml-0 mt-1"> <!--row wrap justify-space-around style="height: 50px"-->
            <!--<v-flex xs12 sm12 md12 text-center row&#45;&#45;dense>-->
                <!--[{{zoneName}}]-->
            <!--</v-flex>-->
            <v-flex  xs12 sm12 md12 fontMiddle :style="{textAlign:$vuetify.breakpoint.smAndDown?'center':'right'}">
                <v-btn  @click="lastWeek" middle class="pl-1 pr-1 mr-2 regFRBtn">
                    上一週
                </v-btn>
                <v-btn @click="thisWeek" middle class="pr-1 pl-1 mr-2 regFRBtn">
                    回本週
                </v-btn>
                <v-btn @click="nextWeek" middle class="pr-1 pl-1 mr-2 regFRBtn">
                    下一週
                </v-btn>
            </v-flex>

            <!--<v-flex fontMiddle>請選擇門診日期、時段、醫師</v-flex>-->

            <v-flex  xs12 sm12 md12 >
                <span class="fontMiddle">[{{zoneName}}] 今天日期: <span :style='this.$store.state.AppSetting.hospId=="weihao"?"color: #BC1D21;font-weight:800":"color: hotpink"'>{{this.$UtilityJs.AD2ROC_Date(new Date().toISOString())}}</span> </span>
            </v-flex>

            <v-flex  xs12 sm12 md12 >
                <span class="fontMiddle">查詢期間: <span :style='this.$store.state.AppSetting.hospId=="weihao"?"color: #BC1D21;font-weight:800":"color: hotpink"'>{{startRange}}</span> </span>
                <span class="fontMiddle"> 至 <span :style='this.$store.state.AppSetting.hospId=="weihao"?"color: #BC1D21;font-weight:800":"color: hotpink"'> {{endRange}}</span> </span>
            </v-flex>


            <v-flex  class="xs12 sm12 md12">

                <clinic-table tr-bg-class="tableHeaderApn1" :go-where="goWhere" :table-title="tableTitle1" :clinic-data="clinicData1" :clinic-headers="clinicHeaders" :loading="loading"></clinic-table>


                <clinic-table tr-bg-class="tableHeaderApn2" :go-where="goWhere" :table-title="tableTitle2" :clinic-data="clinicData2" :clinic-headers="clinicHeaders" :loading="loading"></clinic-table>


                <clinic-table tr-bg-class="tableHeaderApn3" :go-where="goWhere" :table-title="tableTitle3" :clinic-data="clinicData3" :clinic-headers="clinicHeaders" :loading="loading"></clinic-table>


            </v-flex>

        </v-flex>

        <v-flex :class="['xs12 sm12 md3 mt-1',$vuetify.breakpoint.smAndDown?'pl-1':'pl-7 pr-5']">
            <p v-html="regNote"></p>

        </v-flex>



    </v-layout>
</template>

<script>
    import ClinicTable from './ClinicTable'
    export default {
        name: "ClinicB",
        components:{ClinicTable},
        data() {
            return {
                zoneName:'',
                goWhere:'daan',
                tableTitle1:'上午',
                tableTitle2:'下午',
                tableTitle3:'晚上',
                startRange:'',
                endRange:'',
                clinicData: [],
                loading:false,
                loadingText:'查詢中...',
                clinicData1:[],
                clinicData2:[],
                clinicData3:[],
                clinicHeaders:[
                    {
                        text: '診間名稱',
                        // align: 'left',
                        value: 'clinicName',
                        class:'px-1'
                    },
                    {
                        text: '星期一',
                        // align: 'left',
                        value: 'viewItemName1',
                        class:'px-1'
                    },
                    {
                        text: '星期二',
                        // align: 'left',
                        value: 'viewItemName2',
                        class:'px-1'
                    },
                    {
                        text: '星期三',
                        // align: 'left',
                        value: 'viewItemName3',
                        class:'px-1'
                    },
                    {
                        text: '星期四',
                        // align: 'left',
                        value: 'viewItemName4',
                        class:'px-1'
                    },
                    {
                        text: '星期五',
                        // align: 'left',
                        value: 'viewItemName5',
                        class:'px-1'
                    },
                    {
                        text: '星期六',
                        // align: 'left',
                        value: 'viewItemName6',
                        class:'px-1'
                    },
                    {
                        text: '星期日',
                        // align: 'left',
                        value: 'viewItemName7',
                        class:'px-1'
                    },
                ],
                startDate:'',
                endDate:'',
                regNote:'',
            }
        },
        created(){
            let today = this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString(),'date');
            this.startDate = today;
            this.startDate = this.getStartDate();
            this.endDate = this.getEndDate();
            this.axios_getClinicData();
            let divCode = this.$route.params.divCode==undefined?'ALL':this.$route.params.divCode;
            let empNo = this.$route.query.empNo==undefined?'':this.$route.query.empNo;
            this.axios_getRegNote(divCode+','+empNo);
            this.axios_getZoneName();
        },
        watch: {
            '$route.params': function () {
                this.axios_getClinicData();
                let divCode = this.$route.params.divCode==undefined?'ALL':this.$route.params.divCode;
                let empNo = this.$route.query.empNo==undefined?'':this.$route.query.empNo;
                this.axios_getRegNote(divCode+','+empNo);
                this.axios_getZoneName();
            },
        },
        methods:{
            setHeader(data){
                return data.filter((i) => {
                    return i.clinicNo== 9999;
                })
            },
            setNotHeader(data){
                return data.filter((i) => {
                    return i.clinicNo!== 9999;
                })
            },
            thisWeek(){
                let today = this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString(),'date');
                this.startDate = today;
                this.startDate = this.getStartDate();
                this.endDate = this.getEndDate();
                this.axios_getClinicData();
            },
            lastWeek(){
                this.startDate = this.getLastWeek(this.startDate);
                this.endDate= this.getEndDate();
                this.axios_getClinicData();
            },
            nextWeek(){
                this.startDate = this.getNextWeek(this.startDate);
                this.endDate = this.getEndDate();
                this.axios_getClinicData();
            },
            getStartDate(){ //取得當下日期 當周 星期一
                // let startDate = new Date(this.startDate+" 00:00:00")
                let sDate = this.startDate.replace(new RegExp("-","gm"),"");
                let y = sDate.substring(0,4);
                let m = sDate.substring(4,6);
                let d = sDate.substring(6,8)
                let startDate = new Date(parseInt(y), parseInt(m)-1, parseInt(d), 0, 0, 0, 0);

                if(startDate.getDay() == 0)
                {
                    startDate.setDate(startDate.getDate() - 6);
                }
                else
                {
                    startDate.setDate(startDate.getDate() - (startDate.getDay()-1));
                }
                return this.$UtilityJs.AD2ROC_DateTime(startDate.toISOString(),'date');

            },
            getEndDate(){ //取得當下日期 當周 星期日
                // let endDate = new Date(this.startDate);
                // let endDate = new Date(this.startDate+" 00:00:00");
                let eDate = this.startDate.replace(new RegExp("-","gm"),"");
                let y = eDate.substring(0,4);
                let m = eDate.substring(4,6);
                let d = eDate.substring(6,8)
                let endDate = new Date(parseInt(y), parseInt(m)-1, parseInt(d), 0, 0, 0, 0);

                if(endDate.getDay() != 0)
                {
                    endDate.setDate(endDate.getDate() + (7-endDate.getDay()));
                }
                return this.$UtilityJs.AD2ROC_DateTime(endDate.toISOString(),'date');
            },
            getNextWeek(start){ //取得下一周
                // let endDate = new Date(start+" 00:00:00");
                let eDate = start.replace(new RegExp("-","gm"),"");
                let y = eDate.substring(0,4);
                let m = eDate.substring(4,6);
                let d = eDate.substring(6,8)
                let endDate = new Date(parseInt(y), parseInt(m)-1, parseInt(d), 0, 0, 0, 0);

                if(endDate.getDay() != 0)
                {
                    endDate.setDate(endDate.getDate() + (8-endDate.getDay()));
                }
                return this.$UtilityJs.AD2ROC_DateTime(endDate.toISOString(),'date');
            },
            getLastWeek(start){ //取得上一周
                // let endDate = new Date(start+" 00:00:00");
                let eDate = start.replace(new RegExp("-","gm"),"");
                let y = eDate.substring(0,4);
                let m = eDate.substring(4,6);
                let d = eDate.substring(6,8)
                let endDate = new Date(parseInt(y), parseInt(m)-1, parseInt(d), 0, 0, 0, 0);

                if(endDate.getDay() != 0)
                {
                    endDate.setDate(endDate.getDate() - (8-endDate.getDay()));
                }
                return this.$UtilityJs.AD2ROC_DateTime(endDate.toISOString(),'date');
            },
            setHeaders(data){
                this.clinicHeaders = [];
                this.clinicHeaders.push(
                    {
                        text: data[0].clinicName,
                        // align: 'left',
                        value: 'clinicName',
                        class:'px-1'
                    },
                    {
                        text: data[0].clinicTable[0].viewItemName1+'<br/>'+data[0].clinicTable[0].viewItemUrl1,
                        // align: 'left',
                        value: 'viewItemName1',
                        class:'px-1'
                    },
                    {
                        text: data[0].clinicTable[0].viewItemName2+'<br/>'+data[0].clinicTable[0].viewItemUrl2,
                        // align: 'left',
                        value: 'viewItemName2',
                        class:'px-1'
                    },
                    {
                        text: data[0].clinicTable[0].viewItemName3+'<br/>'+data[0].clinicTable[0].viewItemUrl3,
                        // align: 'left',
                        value: 'viewItemName3',
                        class:'px-1'
                    },
                    {
                        text: data[0].clinicTable[0].viewItemName4+'<br/>'+data[0].clinicTable[0].viewItemUrl4,
                        // align: 'left',
                        value: 'viewItemName4',
                        class:'px-1'
                    },
                    {
                        text: data[0].clinicTable[0].viewItemName5+'<br/>'+data[0].clinicTable[0].viewItemUrl5,
                        // align: 'left',
                        value: 'viewItemName5',
                        class:'px-1'
                    },
                    {
                        text: data[0].clinicTable[0].viewItemName6+'<br/>'+data[0].clinicTable[0].viewItemUrl6,
                        // align: 'left',
                        value: 'viewItemName6',
                        class:'px-1'
                    },
                    {
                        text: data[0].clinicTable[0].viewItemName7+'<br/>'+data[0].clinicTable[0].viewItemUrl7,
                        // align: 'left',
                        value: 'viewItemName7',
                        class:'px-1'
                    },
                )
            },

            filterClinicData(arrayList,apn){
                let data = [];
                arrayList.filter(function (item,i) {
                    item.clinicTable.filter(function (subItem,index,array) {

                        if(index==apn){
                            data.push(array[index]);
                            data[i].clinicName = item.clinicName;
                            data[i].clinicNo = item.clinicNo;
                        }
                    })

                })
                return data;
            },
            axios_getClinicData (){ //門診清單
                this.loading = true;
                let url = '';
                let start = this.startDate.replace(new RegExp("-","gm"),"");
                let end =   this.endDate.replace(new RegExp("-","gm"),"");
                start = parseInt(start.substring(0,4))-1911+""+start.substring(4,8)
                end = parseInt(end.substring(0,4))-1911+""+end.substring(4,8)

                this.startRange = this.$UtilityJs.AD2ROC_Date(this.startDate);
                this.endRange = this.$UtilityJs.AD2ROC_Date(this.endDate);

                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                let divCode = this.$route.params.divCode==undefined?'ALL':this.$route.params.divCode;
                let empNo = this.$route.query.empNo==undefined?'ALL':this.$route.query.empNo;
                url = this.$store.state.AppSetting.backSrvUrl + "clinicparam/clinictable/"+zone+"/"+start+"/"+end+"/"+divCode+"/"+empNo;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.clinicData = response.data.resultSet;
                        let header = this.setHeader(this.clinicData);
                        this.setHeaders(header);
                        this.loading = false;
                        let noHeaderArray =  this.setNotHeader(this.clinicData);
                        this.clinicData1 = this.filterClinicData(noHeaderArray,0);
                        this.clinicData2 = this.filterClinicData(noHeaderArray,1);
                        this.clinicData3 = this.filterClinicData(noHeaderArray,2);


                    }else{
                        this.clinicData = [];
                        this.clinicData1 = [];
                        this.clinicData2 = [];
                        this.clinicData3 = [];
                        this.loading = false;
                    }
                }).catch(error =>  {

                    try {
                        this.clinicData = [];
                        this.clinicData1 = [];
                        this.clinicData2 = [];
                        this.clinicData3 = [];
                        this.loading = false;
                        console.log(error.response.data.status);

                    } catch(err) {
                        this.clinicData = [];
                        this.clinicData1 = [];
                        this.clinicData2 = [];
                        this.clinicData3 = [];
                        this.loading = false;
                    }

                });
            },
            axios_getRegNote (codeNo){ //掛號說明
                this.regNote = '';
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "regnote/datasearch/primarykeys/"+zone+"/CLINIC/"+codeNo;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        for(let i in response.data.resultSet){
                            if(response.data.resultSet[i].regNote!==undefined&&response.data.resultSet[i].regNote!==''){
                                this.regNote+=response.data.resultSet[i].regNote+"<br/>"
                            }
                        }
                    }else{
                        this.regNote = '';
                    }


                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.regNote = '';
                    } catch(err) {
                        this.regNote = '';
                    }
                });
            },
            axios_getZoneName (){  //查詢院區名稱
                this.zoneName = '';
                let url = '';
                let zone = this.$route.query.zone==undefined?this.$store.state.AppSetting.zone:this.$route.query.zone;
                url = this.$store.state.AppSetting.backSrvUrl + "zoneset/datasearch/primarykeys/"+zone;
                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.zoneName = response.data.resultSet[0].zoneName;
                    }else{
                        this.zoneName ='';
                    }
                }).catch(error =>  {
                    this.zoneName = '';
                    try {
                        console.log(error.response.data.status);

                    } catch(err) {
                        console.log(err.toString())
                    }
                });
            },

        }
    }
</script>

<style scoped>



</style>